var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('canvas',{ref:"chart",attrs:{"width":"300","height":"300"}})])}
var staticRenderFns = []

export { render, staticRenderFns }